import * as actionTypes from "./actionTypes";

export const initialState = {
    currentPrepaidBalance: 0
};

export const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.SET_CURRENT_PREPAID_BALANCE:
            return {
                ...state,
                currentPrepaidBalance: action.currentPrepaidBalance
            };

        default:
            return state;
    }
};
